import { SHOP_ID } from '@/utils/const'
import flat from './flat'
import { cartUrl } from './const'
///api/mall/proxy/cart/get_stepped_discount_items

export function getDiscountData(activityId, shopId = SHOP_ID) {
  return flat(`${cartUrl}/get_stepped_discount_items?activityId=${activityId}&shopId=${shopId}`)
}
